import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { forcePasswordChangeGuard, mustChangePasswordGuard } from '@core/guard/force-password-change.guard';
import { LoggedGuard } from '@core/guard/logged.guard';
import { NotLoggedGuard } from '@core/guard/not-logged.guard';

const routes: Routes = [
  // Auth
  {
    path: 'auth',
    canActivate: [NotLoggedGuard],
    loadChildren: () => import('./children/auth/auth.module').then(m => m.AuthModule),
  },
  // Mandatory password change, outside the main shell
  {
    path: 'cambio-password',
    canActivate: [LoggedGuard, mustChangePasswordGuard],
    loadComponent: () =>
      import('./children/force-password-change/force-password-change.component').then(
        c => c.ForcePasswordChangeComponent,
      ),
  },
  // Main
  {
    path: '',
    canActivate: [LoggedGuard, forcePasswordChangeGuard],
    loadChildren: () => import('./children/main/main.module').then(m => m.MainModule),
  },
  // Wild card
  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
